module.exports = __webpack_public_path__ + "assets/img/barrel-hit.d3bd2365.png";